import type { ChangeEventHandler, HTMLProps } from "react";
import styles from "./styles.module.scss";

type Props = HTMLProps<HTMLInputElement> & {
  onChange?: ChangeEventHandler<HTMLInputElement>;
  containerProps?: HTMLProps<HTMLLabelElement>;
};
const ToggleSwitch = ({
  checked,
  onChange,
  containerProps,
  ...props
}: Props) => {
  return (
    <label
      className={styles["toggle-switch"]}
      tabIndex={0}
      role="switch"
      aria-checked={!!checked}
      {...containerProps}
    >
      <input
        aria-hidden="true"
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <span aria-hidden="true" className={styles["switch"]} />
    </label>
  );
};

export default ToggleSwitch;
